import React from "react";
import Grid from "@material-ui/core/Grid";
import tafqeet from "../../../utils/tafqeet";

function BodyConferm({ dataConfirm,found }) {
    const styR = { fontWeight: "1200", textAlign: "right", direction: "rtl", paddingBottom: "0.5rem" };
    const styRD = {
        fontWeight: "1200", textAlign: "right", direction: "rtl", paddingBottom: "0.5rem",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    };

    const styLD = {
        fontWeight: "1200", textAlign: "left", direction: "ltr", paddingBottom: "0.5rem",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
    };

    const styRBi = {
        fontWeight: "bold", textAlign: "right", direction: "rtl",
        fontSize: "1.1rem", paddingBottom: "0.5rem"
    };

    const styLBi = {
        fontWeight: "bold", textAlign: "left", direction: "ltr",
        fontSize: "1.1rem", paddingBottom: "0.5rem"
    };
    const styL = { fontWeight: "1200", textAlign: "center", direction: "ltr", textAlign: "left" };

    const styRi = {
        fontWeight: "1200",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        fontWeight: "bold",
        direction: "rtl",
        fontFamily: "Amiri-Regular",
        textAlign: "right"
    };

    const styLi = {
        fontWeight: "1200",
        whiteSpace: 'pre-wrap',
        overflowWrap: 'break-word',
        fontWeight: "bold",
        direction: "ltr",
        fontFamily: "Amiri-Regular",
        textAlign: "Left"
    };

    const tot_balance = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(dataConfirm.balance);


    return (
        <Grid item container
            justifyContent="center"
            style={{
                paddingTop: "1rem", fontWeight: "bold", fontFamily: "Amiri-Regular",
            }}>

            <Grid item container xs={12} style={{ paddingTop: "0.5rem", paddingBottom: "0.5rem" }}>
                <Grid item container xs={12} style={{
                    fontFamily: "Amiri-Regular", border: "solid 2px", paddingTop: "0.5rem",
                    paddingBottom: "0.5rem", borderRadius: "px", textAlign: "center"
                }}
                >
                    <Grid item container xs={6} style={{ paddingLeft: "0.7rem" }}>
                        <Grid item xs={4} style={styLBi} >
                            {"Name " + "   :    "}
                        </Grid>
                        <Grid item xs={8} style={styLBi} >
                            {dataConfirm.cust?.name}
                        </Grid>

                        <Grid item xs={12} >
                            <div style={styLBi}>      {"Greetings،،، "}</div>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={12} style={styLBi} >
                            <div style={styLBi}>  {"1 - Account Confirmation Request"}</div>
                        </Grid>
                        <div style={styLi}>
                            {"We extend our best regards and wish you continued progress and prosperity.،،"}
                            {"Upon the request of our auditors ,who are currentlly conducting the annual examination of our records, "}

                            {"we kindly request that you kindly certify your account which is in "} {dataConfirm?.date}
                        </div>
                        <Grid item xs={4} style={styL}>
                            {"An amount of " + "    :   "}
                        </Grid>
                        <Grid item xs={8} style={styLBi}>
                            {tot_balance}
                        </Grid>


                        <Grid item xs={12} style={styL}>
                            {tafqeet(dataConfirm?.balance, "SAR")}
                        </Grid>

                        <Grid item xs={12} style={styL}>
                            {"Date" + "    :   "} {dataConfirm?.date}
                        </Grid>

                        <Grid item xs={12} style={styLD}>
                            {"Receipt Date  :............................."}
                        </Grid>
                        <Grid item xs={12} style={styLD}>
                            {"Signature :......................."}
                        </Grid>
                        <br/>
                        <br/>


                        <Grid item xs={12} style={styL}>
                            {"Notes: Your Balance will be considered confirmed as per our records unless we receive a reply from you within ten days of your receipt date"}
                        </Grid>


                        <Grid item xs={12} style={styL}>
                            {" Accounts Manager :......................."}
                        </Grid>

                        <Grid item xs={12} style={styLBi}>
                        </Grid>
                        <br/>
                        <br/>
                        <Grid item xs={12} style={styLBi}>

                            {"2 - Account Confirmation"}
                        </Grid>
                        <Grid item xs={4} style={styL}>
                            {" We confirm the balance" + " /"}
                        </Grid>
                        <Grid item xs={8} style={styL}>
                            {found.nameA}
                        </Grid>
                        
                        <Grid item xs={12} style={styLD}>
                            {"in our records as of   /  /  is correct/matching."}
                        </Grid>
                        <br/>
                        <br/>
                        <Grid item xs={12} style={styL}>
                            {"(In case the account balance does not match, please send us your account statement from your records so we can reconcile it with ours.)"}
                        </Grid>
                        <Grid item xs={12} style={styL}>
                            {"Name :..........................................."}
                        </Grid>
                        <Grid item xs={12} style={styL}>
                            {"Title :........................................"}
                        </Grid>
                        <Grid item xs={12} style={styL}>
                            {"Signature and Stamp:..................................... "}
                        </Grid>
                    </Grid>

                    <Grid item container xs={6} style={{ paddingRight: "0.7rem" }}>
                        <Grid item xs={8} style={styRBi} >
                            {dataConfirm.cust?.name}
                        </Grid>
                        <Grid item xs={4} style={styRBi} >
                            {"الاسم " + "   :    "}
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={10} >
                            <div style={styRBi}>      {"تحية طيبة و بــعد ،،، "}</div>
                        </Grid>
                        <Grid item xs={2}></Grid>
                        <Grid item xs={12} style={styRBi} >
                            <div style={styRBi}>  {"1- طلب مصادقة حـساب"}</div>
                        </Grid>
                        <div style={styRi}>
                            {"نهديكم أطيب تحياتنا و نتمنى لـكم دوام الــتقــدم و الازدهار،،،"}
                            {"بناء عـلى طلب مدقـقي حساباتنا والذي يقومون حاليا باجراءات الفحص السنوي لسجلاتنا نرجوا منكم "}
                            {"شاكرين تكرمكم بالمصادقة على رصيد حسابكم كما هو في"}  {dataConfirm?.date}
                        </div>
                        <Grid item xs={8} style={styRBi}>
                            {tot_balance}
                        </Grid>
                        <Grid item xs={4} style={styR}>
                            {"البالغ" + "    :   "}
                        </Grid>

                        <Grid item xs={12} style={styR}>
                            {tafqeet(dataConfirm?.balance, "SAR")}
                        </Grid>

                        <Grid item xs={12} style={styR}>
                            {"التاريخ" + "    :   "} {dataConfirm?.date}
                        </Grid>

                        <Grid item xs={12} style={styRD}>
                            {"تاريـخ الاسـتلام :............................."}
                        </Grid>
                        <Grid item xs={12} style={styRD}>
                            {"الـتوقــيع :......................."}
                        </Grid>
                        <br/>
                        <br/>
                        <Grid item xs={12} style={styR}>
                            {"ملاحظة يعتبر رصيدكم مطابقا عليه كما هو في سجلاتنا مالم نستلم ردا منكم خلال عشرة ايام من تاريخ استلامكم"}
                        </Grid>

                        <Grid item xs={12} style={styR}>
                            {"مدير الحسابات :......................."}
                        </Grid>

                        <Grid item xs={12} style={styRBi}>
                        </Grid>
                        <br/>
                        <br/>
                        <Grid item xs={12} style={styRBi}>
                            {"2- المصادقة على حـساب"}
                        </Grid>
                        <Grid item xs={8} style={styR}>
                            {found.nameA}
                        </Grid>
                        <Grid item xs={4} style={styR}>
                            {"نصادق على رصيد " + " /"}
                        </Grid>

                        <Grid item xs={12} style={styRD}>
                            {"في سجلاتنا كما هو بتاريخ        /     /          مطابق "}
                        </Grid>
                        <Grid item xs={12} style={styR}>
                            {"(في حال كون الحساب غير مطابق نأمل منكم ارسال كشف حسابنا من واقع سجلاتكم لنتمكن من مطابقته مع سجلاتنا )"}
                        </Grid>
                        <Grid item xs={12} style={styR}>
                            {"الاسم :..........................................."}
                        </Grid>
                        <Grid item xs={12} style={styR}>
                            {"الصـفه :........................................"}
                        </Grid>
                        <Grid item xs={12} style={styR}>
                            {"التوقيع و الختم :..................................... "}
                        </Grid>
                    </Grid>


                </Grid>

            </Grid>

        </Grid>
    );
}
export default BodyConferm;